<section2 [title]="card?.typeLabel | titlecase">
    <div section2cta>
        <action-inline class="b-b b-col-1 p-b-1"
                       [status]="card?.removeStatus"
                       [notification]="'Card removal error'"
                       (click)="card?.remove()">
            Remove
        </action-inline>
    </div>
    <account-saved-card-body [card]="card"
                             section2content
                             class="block"></account-saved-card-body>
</section2>
